import React from "react";
import "./CurrencyPairs.css";

const CurrencyModal = ({
  isOpen,
  onClose,
  formData,
  setFormData,
  onSubmit,
  isEditing,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal">
        <h2>{isEditing ? "Edit Currency Pair" : "Add Currency Pair"}</h2>
        <form onSubmit={onSubmit} className="modal-form">
          <label>Base Currency</label>
          <input
            type="text"
            value={formData.base}
            onChange={(e) =>
              setFormData({ ...formData, base: e.target.value.toUpperCase() })
            }
            required
          />

          <label>Quote Currency</label>
          <input
            type="text"
            value={formData.quote}
            onChange={(e) =>
              setFormData({ ...formData, quote: e.target.value.toUpperCase() })
            }
            required
          />

          <label>Rate</label>
          <input
            type="number"
            value={formData.rate}
            step="0.0001"
            onChange={(e) =>
              setFormData({ ...formData, rate: parseFloat(e.target.value) })
            }
            required
          />

          <div className="modal-actions">
            <button type="submit" className="save-btn">
              {isEditing ? "Update" : "Add"}
            </button>
            <button type="button" onClick={onClose} className="cancel-btn">
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CurrencyModal;
